import { SearchTerm } from "./SearchTerm";

const IOModuleSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "devName",
        translationKey: "name"
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        searchOnName: "devFixedAddr",
        translationKey: "fixedAddress"
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        searchOnName: "devIpAddress",
        translationKey: "ipAddress"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    }
];

export default IOModuleSearch;
